import Vue from "vue";
import store from "@/app/app-state";

const PanelNotifications = {
    noCreditCard: {
        open: () => {
            Vue.notify({ group: "no-credit-card", clean: true });
            Vue.notify({ group: "no-credit-card", duration: -1 });
            store.dispatch("SET_OPENED_NOTIFICATIONS", {
                notification: "noCreditCard",
                isOpened: true,
            });
        },
        close: () => {
            Vue.notify({ group: "no-credit-card", clean: true });
            store.dispatch("SET_OPENED_NOTIFICATIONS", {
                notification: "noCreditCard",
                isOpened: false,
            });
        },
    },
};

export { PanelNotifications };
